import type { ValidationResult } from '../helpers/types';
import { formatValidationResponse } from '../helpers/utils';

const hasOneSpecialCharacterRegex = /([^A-Za-z0-9]+)/;
const specialCharMessage = 'Should have at least one special character';

export const validateOneSpecialChar = (password: string): ValidationResult => {
  const isRuleValid = hasOneSpecialCharacterRegex.test(password);
  return formatValidationResponse(isRuleValid, specialCharMessage);
};
